import { ChevronDownIcon, CheckIcon } from '@chakra-ui/icons';
import { Flex, Stack, Text, Box, useMediaQuery, Tooltip, useOutsideClick } from '@chakra-ui/react';
import { connect, useSelector } from 'react-redux';
import React, { useRef, useState } from 'react';

import BranchIcon from 'components/Icons/BranchIcon';
import {
  fetchAllScenarios,
  getAllScenarios,
  getBaseScenario,
  getCompareScenario,
} from 'redux/ScenarioSlice';
import { Scenario } from 'models/response/scenario.interface';

interface BaseScenarioState {
  currentScenario: Scenario;
  isSelectCompare: boolean;
  selectScenario: (scenario: Scenario) => void;
}
const ScenarioFilter = ({
  selectScenario,
  currentScenario,
  isSelectCompare,
}: BaseScenarioState) => {
  const scenarios = useSelector(getAllScenarios);
  const baseScenario = useSelector(getBaseScenario);
  const compareScenario = useSelector(getCompareScenario);
  const reference = useRef() as React.MutableRefObject<HTMLInputElement>;

  const [isSmallLaptop] = useMediaQuery('(max-width: 1415px)');
  const [showPopover, setShowPopover] = useState(false);

  useOutsideClick({
    ref: reference,
    handler: () => {
      setShowPopover(false);
    },
  });

  const selectCurrentScenario = (scenario: Scenario) => {
    selectScenario(scenario);
    setShowPopover(false);
  };

  return (
    <Stack width={'-moz-fit-content'}>
      {scenarios?.length > 0 && (
        <Box ref={reference} height={'40px'}>
          <Flex
            alignSelf='left'
            w='100%'
            minH={isSmallLaptop ? '36px' : '36px'}
            bgColor='#7163D0'
            mb='10px'
            p='0 8px'
            borderRadius={'7px'}
            filter='drop-shadow(0px 0px 8px rgba(0, 0, 0, 0.25))'
            transition='all 0.3s ease-out'
            justifyContent='space-between'
            alignItems='center'
            cursor='pointer'
            onClick={() => setShowPopover(!showPopover)}
          >
            <Flex width='100%' alignItems='center' justifyContent={'space-between'}>
              <Flex>
                <Box display={'flex'} alignItems={'center'}>
                  <BranchIcon height={5} width={5} />
                </Box>
                <Tooltip label={currentScenario?.name}>
                  <Text
                    fontSize={isSmallLaptop ? '2xs' : 'xs'}
                    display={'flex'}
                    alignItems={'center'}
                    color='white'
                    whiteSpace='nowrap'
                    overflow='hidden'
                    ml='2'
                    textOverflow='ellipsis'
                    width={'5rem'}
                    fontFamily='regular_roboto'
                  >
                    {currentScenario?.name}
                  </Text>
                </Tooltip>
              </Flex>
              <ChevronDownIcon boxSize={{ base: 6 }} color='white' alignSelf={'center'} />
            </Flex>
          </Flex>
          {showPopover && (
            <Box borderRadius='14px' width={'fit-content'} minH={isSmallLaptop ? '36px' : '36px'}>
              <Box
                overflowY='auto'
                ml={{ base: '5', md: '3' }}
                filter='drop-shadow(0px 0px 8px rgba(0, 0, 0, 0.25))'
                bg='white'
                border='none'
                width={'180px'}
                borderRadius='14px'
                zIndex={'dropdown'}
                position={'relative'}
                maxHeight={'30vh'}
                // overflowY={'auto'}
                className={'scroll'}
              >
                <Box height={'fit-content'} maxHeight={'30vh'} m={'0.8rem'} py={'1rem'}>
                  {scenarios?.length > 0 &&
                    scenarios.map((scenario: Scenario, index: number) => {
                      return (
                        <React.Fragment key={index}>
                          {((isSelectCompare && baseScenario?.id !== scenario?.id) ||
                            (!isSelectCompare && compareScenario?.id !== scenario?.id)) && (
                            <Flex
                              alignItems={'center'}
                              justifyContent={'space-between'}
                              key={scenario.id}
                              cursor='pointer'
                              borderRadius='7px'
                              px='1'
                              py='1'
                              onClick={() => selectCurrentScenario(scenario)}
                              bg={
                                baseScenario?.id === scenario?.id ||
                                compareScenario?.id === scenario?.id
                                  ? '#EFEEFE'
                                  : 'transparent'
                              }
                            >
                              <Box display={'flex'} color={'#8B89B1'} alignItems={'center'}>
                                {scenario?.id === currentScenario?.id && (
                                  <CheckIcon height={4} width={4} />
                                )}

                                <Text
                                  px='2'
                                  py='0'
                                  color='black'
                                  fontSize={'xs'}
                                  overflow='hidden'
                                  whiteSpace='nowrap'
                                  textOverflow='ellipsis'
                                  width={'110px'}
                                  fontFamily='regular_roboto'
                                >
                                  {scenario?.name}
                                </Text>
                              </Box>
                            </Flex>
                          )}
                        </React.Fragment>
                      );
                    })}
                </Box>
              </Box>
            </Box>
          )}
        </Box>
      )}
    </Stack>
  );
};

const mapDispatchToProperties = (dispatch: any) => {
  return {
    getAllscenarios: (modelId: number) => dispatch(fetchAllScenarios(modelId)),
  };
};

export default connect(mapDispatchToProperties)(ScenarioFilter);
